import {
  WSElement,
  WSPage,
  WSPageToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import { Tabs } from "../../components/Tabs";
import { useQueryInternalAccounts } from "../../query/banking/queries/useQueryInternalAccounts";
import { useUserId } from "../../query/hooks/helpers";
import { useQueryPayoutSettings } from "../../query/payments/queries";
import { INVOICING_PATH } from "../Invoicing";
import { RouteNewDashboard } from "../Wallet/routes/RouteNewDashboard";
import { RouteNewTransactions } from "../Wallet/routes/RouteNewTransactions";
import { selectorIsPlatformBalanceAccount } from "./selectors/selectorIsPlatformBalanceAccount";
import { EmptyState } from "./components/EmptyState";
import {
  PATH_PLATFORM_BALANCE,
  PATH_PLATFORM_BALANCE_TRANSACTIONS
} from "./paths";

export const RoutePlatformBalance = () => {
  const history = useHistory();
  const userId = useUserId();
  const queryInternalAccounts = useQueryInternalAccounts();
  const queryPayoutSettings = useQueryPayoutSettings(userId);

  const apPayoutAccount = useMemo(
    () =>
      queryInternalAccounts.data?.find(internalAccount =>
        selectorIsPlatformBalanceAccount(
          internalAccount,
          queryPayoutSettings.data
        )
      ),
    [queryInternalAccounts.data, queryPayoutSettings.data]
  );

  return (
    <WSPage>
      <WSPageToolbar
        breadcrumbs={[
          {
            label: "Invoicing",
            onClick: () => history.push(INVOICING_PATH)
          },
          {
            label: "Platform Balance"
          }
        ]}
      />

      <WSElement mb="2XL">
        <WSText.Heading2>Platform Balance</WSText.Heading2>

        <WSText.ParagraphSm color="gray500">
          Hold your earnings securely on the platform until you're ready to
          receive them.
        </WSText.ParagraphSm>
      </WSElement>

      {apPayoutAccount ? (
        <>
          <Tabs
            mb="2XL"
            tabs={[
              {
                label: "Overview",
                path: PATH_PLATFORM_BALANCE
              },
              {
                label: "Transactions",
                path: PATH_PLATFORM_BALANCE_TRANSACTIONS
              }
            ]}
          />

          <Switch>
            <Route
              path={PATH_PLATFORM_BALANCE_TRANSACTIONS}
              render={() => (
                <RouteNewTransactions
                  internalAccountId={apPayoutAccount.internalAccountId}
                />
              )}
            />

            <Route
              path={PATH_PLATFORM_BALANCE}
              render={() => (
                <RouteNewDashboard
                  internalAccountId={apPayoutAccount.internalAccountId}
                />
              )}
            />
          </Switch>
        </>
      ) : (
        <EmptyState />
      )}
    </WSPage>
  );
};
